export type { ButtonProps } from "./ButtonProps";
import Button from "./Button";
export default Button;
